module.exports = __webpack_public_path__ + "img/pro_12.d9d7178e.png";